import { render, staticRenderFns } from "./PsReportsDetail.vue?vue&type=template&id=48dde7b6&scoped=true&"
import script from "./PsReportsDetail.vue?vue&type=script&lang=js&"
export * from "./PsReportsDetail.vue?vue&type=script&lang=js&"
import style0 from "./PsReportsDetail.vue?vue&type=style&index=0&id=48dde7b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dde7b6",
  null
  
)

export default component.exports